export default [
	{
		path: 'todo-list',
		component: () => import ('@/components/page/quote-by-product/todoList/todoList'),
		meta: {title: 'nav.todoList'}
	}
];
